import { render } from "./PromotionsSection.vue?vue&type=template&id=ae43fbe4"
import script from "./PromotionsSection.vue?vue&type=script&lang=js"
export * from "./PromotionsSection.vue?vue&type=script&lang=js"

import "./PromotionsSection.vue?vue&type=style&index=0&id=ae43fbe4&lang=css"
script.render = render

export default script